import { AppShell } from "@/components/layout/AppShell";
import { useAuth } from "@/context/AuthContext";
import { PasswordCard, ProfileCard } from "@/components/account/ProfileCards";
import { UsersManager } from "@/components/account/UsersManager";

export default function Account() {
  const { user } = useAuth();
  const admin = (user as any)?.role === "admin";
  return (
    <AppShell title="Account & Users">
      <div className="space-y-5" data-testid="account-page">
        <ProfileCard />
        <PasswordCard />
        {admin && <UsersManager />}
      </div>
    </AppShell>
  );
}
